// extracted by mini-css-extract-plugin
export default {"div":"Home_div__VaKQg"};